export default {
    state: {
        selectedResponsible: null,
    },
    actions: {},
    mutations: {
        Change_Responsible_Selected: function (state, val) {
            state.selectedResponsible = val;
        },
    },
    getters: {}
};
